module.exports = __webpack_public_path__ + "MaterialIcons-Regular.570eb83859dc23dd0eec.woff2";


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/@covalent/core/common/styles/font/MaterialIcons-Regular.woff2
// module id = ../../../../@covalent/core/common/styles/font/MaterialIcons-Regular.woff2
// module chunks = 2